import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { BASE_URL } from "./Config";
import axios from "axios";
import { Link } from "react-router-dom";
export default function HowToBid() {
  const [privacy_p, setprivacy_p] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_how_to_bid.php?t=${Date.now()}`)
      .then((res) => {

        console.log(res)
        if (res.data.success) {
          setprivacy_p(res.data.data);
          console.log(res.data.data);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, []);
  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span> /</span>
                <p>HOW TO BID</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div
            className="row"
            dangerouslySetInnerHTML={{
              __html: String(privacy_p.content),
            }}
          ></div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
